module.exports = __webpack_public_path__ + "static/media/ap3.f56935d2.jpg";